import { ContentTypes } from "@/search/NewSearchPageMVP/FilterPanel/filters/ContentTypes/ContentTypes.component";

export { ContentTypes };
